import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Box,
  Table as MuiTable,
  TableBody,
  withTheme
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TableListItem from "../../../waybee-ui/TableList/TableListItem";

const Table = styled(MuiTable)`
  width: calc(100% + 60px);
  max-height: calc(100vh - 430px);
  margin: 0 -30px -20px;
  border: solid #f2f2f2;
  border-width: 2px 0 2px 0;
`;

const TeacherList = ({ teachers, onSelectItem, theme }) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Table aria-label="simple table">
        <TableBody>
          {teachers.map(teacher => {
            const listItem = {
              ...teacher,
              title: teacher.NOME,
              description: teacher.FUNCAO,
              info: teacher.SDISCIPLINA_NOME
            };

            return (
              <TableListItem
                key={teacher.CODPROF || teacher.id || teacher.CODIGO}
                statusText={t("teachers.moreInfo")}
                statusIcon="add_circle_outline"
                statusColor={theme.palette.primary.main}
                infoIcon="bookmark"
                item={listItem}
                onSelectitem={onSelectItem}
              />
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

TeacherList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  teachers: PropTypes.array.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object.isRequired // Get from withTheme()
};

export default withTheme(TeacherList);
